import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined'
import ProgressBar from './ProgressBar';
import TextFields_Outlined_Long from './TextFields_Outlined_Long'
import MultiSelect_Checkbox_Outlined from './MultiSelect_Checkbox_Outlined'
import Dropdown_Advanced from './Dropdown_Advanced'
import TextFields_Outlined_Phone from './TextMasks/TextMask_Phone'
import TimePicker from './TimePicker'
import TextArea_Simple from './TextArea_Simple'
import SlideInAlert from './SlideInAlert'
import MySectionBlock from './MySectionBlock'
import ValidationModal from './ValidationModal';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

/* Button */
import Button from '@material-ui/core/Button';
/* Grid */
import { createTheme, ThemeProvider  } from "@material-ui/core";
/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import districts from '../data/districts.json'
import schools from '../data/schools.json'
import grades from '../data/grades.json'
/*import genders from '../data/genders.json'*/

import ColumnStatus from './ColumnStatus'

/* Bottom Nav */


/* Context */
import ContentContext from './ContentContext'
import { TranslationColumn1Context } from './TranslationContexts/TranslationColumn1Context'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import MultipleSelect from './MultiSelect_Checkbox';

/* Accordion */
import Directions_Accordion from './Directions_Accordion'
/* Date Picker */
import DatePicker_Simple from './DatePicker_Simple'
import DatePicker_Time from './DatePicker_Time'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FcCalendar } from 'react-icons/fc';

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import Checkbox_Regular from './Checkbox_Regular';
import { red } from '@material-ui/core/colors';

import { useDispatch, useSelector } from 'react-redux'
import { dueDate_intUpdated, dueTime_intUpdated, interpretationTypes_intUpdated, testingSubject_intUpdated, estimatedDurationHrs_intUpdated, estimatedDurationMins_intUpdated, paperWorkChecked_intUpdated, needInterpreterChecked_intUpdated, inPersonMeetingChecked_intUpdated, teleconference_intUpdated, teleconferencePhone_intUpdated, onlineOrVirtChecked_intUpdated, onlineMeetingLink_intUpdated, studentName_intUpdated, phone_intUpdated, grade_intUpdated, gender_intUpdated, languageDropdown_intUpdated, otherLanguages_intUpdated, districtDropdown_intUpdated, schoolDropdown_intUpdated, address_intUpdated, contactName_intUpdated, contactPhone_intUpdated, contactEmail_intUpdated, approverName_intUpdated, approverPosition_intUpdated, approverEmail_intUpdated, studentDistrictDropdown_intUpdated, districtRid_intUpdated, schoolRid_intUpdated, approverSignatureFile_intUpdated, tableData_intUpdated, notes_intUpdated, coser_intUpdated, docToInterperateFiles_intUpdated } from '../redux/slices/interpretationSlice';


const TranslationContent = ({ handleContinueButton, handleProgressBarChange }) => {
  const today = new Date();
  const dispatch = useDispatch();
  const interpretationState = useSelector((state) => state.interpretation); // Access translation state



  const { contentState, setContentState } = useContext(ContentContext)
  //const { dataContext, setDataContext } = useContext(TranslationDataContext)

  const dataForQB = useTranslation()
  const setDataForQB = useTranslationUpdate()

  const [progressBarClass, setProgressBarClass] = useState('')

  const useStyles = createTheme((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  //const classes = useStyles();

  //////////////////////////////////////////////////////////////
  // COLUMN VALIDATION - UI TO SHOW THIS
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 1
  //////////////////////////////////////////////////////////////
  const [translationTypes, setTranslationTypes] = useState(''); // new one for multi-select
  const handleTranslationTypeChanges = (selectedTypes) => {
    setTranslationTypes(selectedTypes);
  }
  const [isTeleconference, setIsTeleconference] = useState(false)
  const [isOnlineOrVitrualMeeting, setIsOnlineOrVirtualMeeting] = useState(false)
  const [isNeedInterpreterChecked, setIsNeedInterpreterChecked] = useState (false)
  const [col1RequiredFields, setCol1RequiredFields] = useState({
    dueDate_int: '',
    dueTime_int: '',
    interpretationTypes_int: '',
    estimatedDurationHrs_int: '',
    estimatedDurationMins_int: '',
    phone_int: '',
    testingSubject_int: ''
  })
  const [renderTestingSubject, setRenderTestingSubject] = useState(false)
  const [column1Complete, setColumn1Complete] = useState(false)
  const updateColumn1Count = (id, valueInInput) => {
    
    //alert("COL 1 update")
    col1RequiredFields["dueDate_int"] = dataForQB.dueDate_int;
    col1RequiredFields["dueTime_int"] = dataForQB.dueTime_int;
    col1RequiredFields["interpretationTypes_int"] = dataForQB.interpretationTypes_int;
    col1RequiredFields["estimatedDurationHrs_int"] = dataForQB.estimatedDurationHrs_int;
    col1RequiredFields["estimatedDurationMins_int"] = dataForQB.estimatedDurationMins_int;
    col1RequiredFields["phone_int"] = dataForQB.phone_int;
    col1RequiredFields["testingSubject_int"] = dataForQB.testingSubject_int;
    setIsNeedInterpreterChecked(dataForQB.needInterpreterChecked_int)
    let allFilledOut = true;

    for (var key in col1RequiredFields) {
      //console.log("key " + key + " has value " + col2RequiredFields[key]);
      if (key == id) {
        col1RequiredFields[key] = valueInInput
        // Set the POST obj
        dataForQB[key] = valueInInput;
      }
    }

    //alert(id + "/" + valueInInput)

    // This needs to be updated here because no longer using the setUnrequired func
    if (id=="needInterpreterChecked_int") {
      setIsNeedInterpreterChecked(valueInInput)
      dataForQB.needInterpreterChecked_int = valueInInput;
    }

    if (id=="dueTime_int") {
      if (valueInInput != ""){
        console.log("START")
        console.log(valueInInput.target.value)
        console.log(dataForQB.dueTime_int)
        console.log("END")
        setStartDueTime(valueInInput.target.value);
        dataForQB.dueTime_int = valueInInput.target.value;
      }
      else{
        setStartDueTime("")
        dataForQB.dueTime_int = "";
      }
    }

    

    if (col1RequiredFields.dueDate_int == "") allFilledOut = false;
    if (col1RequiredFields.dueTime_int == "") allFilledOut = false;
    if (col1RequiredFields.interpretationTypes_int == "") allFilledOut = false;
    if (dataForQB.estimatedDurationHrs_int=="" && dataForQB.estimatedDurationMins_int=="") allFilledOut = false;
    let needInterpPassed = false;
    if (!dataForQB.needInterpreterChecked_int) needInterpPassed = true;
    else if (dataForQB.needInterpreterChecked_int && col1RequiredFields.phone_int != "") needInterpPassed = true;
    if (!needInterpPassed) allFilledOut = false;

    if (col1RequiredFields.interpretationTypes_int && col1RequiredFields.interpretationTypes_int.includes("Testing") && col1RequiredFields.testingSubject_int == "") allFilledOut = false;
 
    setColumn1Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn1ColumnStatus = () => {
    let completed = interpretationState.leftColFilledOut_int >= 50 ? true : false
    return <ColumnStatus complete={completed} />
  }

  const[otherInterpAlert, setOtherInterpAlert] = useState(false);

  const handleOtherInterpAlertOpen = () =>{
    //setAlertOnce(true)
  }
  const renderOtherInterpAlert = () =>{
      if (otherInterpAlert) return <SlideInAlert isOpen={true}/>
      else return <></>
  }
  useEffect(()=>{
    if (translationTypes.includes("Other")){
      setOtherInterpAlert(true)
    }
    else setOtherInterpAlert(false)
  },[otherInterpAlert, translationTypes])
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 2
  //////////////////////////////////////////////////////////////
  // States
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [column2Complete, setColumn2Complete] = useState(false)
  const [renderOtherLang, setRenderOtherLang] = useState(false)
  const [col2RequiredFields, setCol2RequiredFields] = useState(
    {
      studentName_int: '',
      languageDropdown_int: '',
      districtDropdown_int: '',
      contactName_int: '',
      contactPhone_int: '',
      contactEmail_int: '',
      approverName_int: '',
      approverPosition_int: '',
      approverEmail_int: ''
    }
  )

  const updateNonRequireField = (id, valueInInput) =>{
    dataForQB[id] = valueInInput
  }

  const updateColumn2Count = (id, valueInInput) => {
    col1RequiredFields["studentName_int"] = dataForQB.studentName_int
    col1RequiredFields["languageDropdown_int"] = dataForQB.languageDropdown_int
    col2RequiredFields["districtDropdown_int"] = dataForQB.districtDropdown_int
    col2RequiredFields["contactName_int"] = dataForQB.contactName_int
    col2RequiredFields["contactPhone_int"] = dataForQB.contactPhone_int
    col2RequiredFields["contactEmail_int"] = dataForQB.contactEmail_int
    col2RequiredFields["approverName_int"] = dataForQB.approverName_int
    col2RequiredFields["approverPosition_int"] = dataForQB.approverPosition_int
    col2RequiredFields["approverEmail_int"] = dataForQB.approverEmail_int
    col2RequiredFields["otherLanguages_int"] = dataForQB.otherLanguages_int

    if (id == "coser_int"){
      dataForQB.coser_int = valueInInput;
    }

    // Clear out
    if (col2RequiredFields["languageDropdown_int"] != "Other"){
      col2RequiredFields["otherLanguages_int"] = "";
      dataForQB.otherLanguages_int = "";
      //alert("NO: " + col2RequiredFields["languageDropdown_int"])
    }
    let allFilledOut = true;
    for (var key in col2RequiredFields) {
      console.log("key " + key + " has value " + col2RequiredFields[key]);

      if (key == id) {
        col2RequiredFields[key] = valueInInput
        // Set the POST obj
        dataForQB[key] = valueInInput;
      }

      if (dataForQB.languageDropdown_int != "Other"){
        col2RequiredFields["otherLanguages_int"] = "n/a";
        dataForQB.otherLanguages_int = "n/a";
      }
      else if (dataForQB.languageDropdown_int == "Other" && 
      (col2RequiredFields["otherLanguages_int"] == "n/a" || dataForQB.otherLanguages_int == "n/a" == "n/a")
      ){
        col2RequiredFields["otherLanguages_int"] = "";
        dataForQB.otherLanguages_int = "";
      }

      // No need to validate this field because not using other
      //if (dataForQB.languageDropdown_int != "Other" && id == "otherLanguages_int") continue;

      if (col2RequiredFields[key] == "") {
        allFilledOut = false;
      }
      
    }
    if (id == "districtDropdown_int") {
      setCurrentDistrict(valueInInput)
      //setCurrentDistrict("Babylon")
    }
    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn2ColumnStatus = () => {
    let completed = interpretationState.rightColFilledOut_int >= 50 ? true : false
    return <ColumnStatus complete={completed} />
  }
  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  const resetDropdownValOnConditionalChange = (label) =>{
    dataForQB[label] = "";
  }


  //const progressBarData = { bgcolor: "#00695c", completed: 0 }
  //const [progressBarPercent, setProgressBarPercent] = useState(0)

  const setProgressBarDataInParent = () => {
    if (interpretationState.interpretationTypes_int && interpretationState.interpretationTypes_int.includes("Testing")) setRenderTestingSubject(true);
    else setRenderTestingSubject(false);

    let temp = 0;
    // Col 1 - this is dynamic so use this field instead
    if (col1RequiredFields.dueDate_int != "") temp += 8;
    if (col1RequiredFields.dueTime_int != "") temp += 8;
    if (col1RequiredFields.interpretationTypes_int != "") temp += 7;
    if (col1RequiredFields.interpretationTypes_int && col1RequiredFields.interpretationTypes_int.includes("Testing") && col1RequiredFields.testingSubject_int != "") temp += 1;
    else if (col1RequiredFields.interpretationTypes_int && !col1RequiredFields.interpretationTypes_int.includes("Testing") && col1RequiredFields.interpretationTypes_int != "") temp += 1;
    if (col1RequiredFields.estimatedDurationHrs_int != "" || col1RequiredFields.estimatedDurationMins_int != "") temp += 8;
    if (!isNeedInterpreterChecked || col1RequiredFields.phone_int != "") temp += 8;
    // Col 2
    if (col2RequiredFields.studentName_int != "") temp += 7;
    if (col2RequiredFields.languageDropdown_int != "") temp += 6;
    if (col2RequiredFields.languageDropdown_int == "Other" && col2RequiredFields.otherLanguages_int != "") temp += 1;
    else if (col2RequiredFields.languageDropdown_int != "" && col2RequiredFields.languageDropdown_int != "Other") temp += 1;
    if (col2RequiredFields.districtDropdown_int != "") temp += 7;
    if (col2RequiredFields.contactName_int != "") temp += 7;
    if (col2RequiredFields.contactPhone_int != "") temp += 7;
    if (col2RequiredFields.contactEmail_int != "") temp += 7;
    if (col2RequiredFields.approverName_int != "") temp += 6;
    if (col2RequiredFields.approverPosition_int != "") temp += 6;
    if (col2RequiredFields.approverEmail_int != "") temp += 5;
    if (col2RequiredFields.districtDropdown_int && (!col2RequiredFields.districtDropdown_int.includes("Nassau BOCES") || (col2RequiredFields.districtDropdown_int.includes("Nassau BOCES") && dataForQB.coser_int != ""))) temp += 1;
    handleProgressBarChange(parseInt(temp))
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete, column2Complete]);

  //////////////////////////////////////////////////////////////
  //  Due Date
  //////////////////////////////////////////////////////////////
  const [startDueDate, setStartDueDate] = useState('')
  const [startDueTime, setStartDueTime] = useState('')
  //////////////////////////////////////////////////////////////

  // This fixes the issue where deleting time will not fire event and not uncheck the column
  setInterval(function(){
    if (column1Complete && dataForQB.dueTime_int == ""){
      updateColumn1Count("dueTime_int","")
    }
  },1000)

  //////////////////////////////////////////////////////////////
  // Validations
  //////////////////////////////////////////////////////////////approver email
  const [validate_contactPhone, setValidation_contactPhone] = useState('')
  const [validate_contactEmail, setValidation_contactEmail] = useState('')
  const [validate_approverEmail, setValidation_approverEmail] = useState('')
  const [validate_coser, setValidation_coser] = useState('')
  const [validate_studentPhone, setValidation_studentPhone] = useState('')

  // Validation Modal State
  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [validationModalMissingFields, setValidationModalMissingFields] = useState([]);
  const [validationModalErrors, setValidationModalErrors] = useState([]);

  // Solution 1: Detect autofill and sync values to state
  useEffect(() => {
    const detectAndSyncAutofill = () => {
      const inputs = document.querySelectorAll('input, textarea, select');
      let autofillDetected = false;

      inputs.forEach((input) => {
        // Skip MUI internal elements and date/time pickers
        if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-') ||
            input.id === 'dueDate_int' || input.id === 'dueTime_int') {
          return;
        }

        if (input.value && input.id) {
          const stateValue = interpretationState[input.id];

          if (!stateValue || stateValue !== input.value) {
            autofillDetected = true;
            console.log(`Autofill detected for field: ${input.id}`);
            mapToRedux(input.id, input.value);
            updateColumn2Count(input.id, input.value);
          }
        }
      });

      if (autofillDetected) {
        console.log('Autofill detected on Interpretation page, revalidating form...');
        setTimeout(() => {
          updateColumn2Count();
        }, 100);
      }
    };

    const timer1 = setTimeout(detectAndSyncAutofill, 500);
    const timer2 = setTimeout(detectAndSyncAutofill, 1000);
    const timer3 = setTimeout(detectAndSyncAutofill, 2000);

    const handleInputEvent = (e) => {
      // Skip MUI internal elements and date/time pickers
      if (!e.target.id || e.target.id.startsWith('mui-') || e.target.id.startsWith('react-select-') ||
          e.target.id === 'dueDate_int' || e.target.id === 'dueTime_int') {
        return;
      }

      if (e.target.id && e.target.value) {
        mapToRedux(e.target.id, e.target.value);
        updateColumn2Count(e.target.id, e.target.value);
      }
    };

    const inputs = document.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      input.addEventListener('input', handleInputEvent);
    });

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      inputs.forEach(input => {
        input.removeEventListener('input', handleInputEvent);
      });
    };
  }, []);

  // Solution 3: Get list of missing required fields - check Redux state only
  const getMissingRequiredFields = () => {
    const missingFields = [];

    // Column 1 required fields
    if (!interpretationState.dueDate_int || interpretationState.dueDate_int === '') {
      missingFields.push('Due Date');
    }

    if (!interpretationState.dueTime_int || interpretationState.dueTime_int === '') {
      missingFields.push('Due Time');
    }

    if (!interpretationState.interpretationTypes_int || interpretationState.interpretationTypes_int === '' ||
        (Array.isArray(interpretationState.interpretationTypes_int) && interpretationState.interpretationTypes_int.length === 0)) {
      missingFields.push('Interpretation Type(s)');
    }

    // At least one duration field must be filled
    if ((!interpretationState.estimatedDurationHrs_int || interpretationState.estimatedDurationHrs_int === '') &&
        (!interpretationState.estimatedDurationMins_int || interpretationState.estimatedDurationMins_int === '')) {
      missingFields.push('Estimated Duration (Hours or Minutes)');
    }

    // Testing subject required if "Testing" is selected
    if (interpretationState.interpretationTypes_int &&
        interpretationState.interpretationTypes_int.includes("Testing") &&
        (!interpretationState.testingSubject_int || interpretationState.testingSubject_int === '')) {
      missingFields.push('Testing Subject');
    }

    // Parent/Guardian phone required if "Need Interpreter" is checked
    if (interpretationState.needInterpreterChecked_int && (!interpretationState.phone_int || interpretationState.phone_int === '')) {
      missingFields.push('Parent/Guardian Phone');
    }

    // Column 2 required fields
    if (!interpretationState.studentName_int || interpretationState.studentName_int === '') {
      missingFields.push('Student Name');
    }

    if (!interpretationState.grade_int || interpretationState.grade_int === '') {
      missingFields.push('Grade');
    }

    if (!interpretationState.languageDropdown_int || interpretationState.languageDropdown_int === '') {
      missingFields.push('Language');
    }

    if (renderOtherLang && (!interpretationState.otherLanguages_int || interpretationState.otherLanguages_int === '')) {
      missingFields.push('Other Language (Details)');
    }

    if (!interpretationState.districtDropdown_int || interpretationState.districtDropdown_int === '') {
      missingFields.push('District');
    }

    if (!interpretationState.schoolDropdown_int || interpretationState.schoolDropdown_int === '') {
      missingFields.push('School');
    }

    if (!interpretationState.address_int || interpretationState.address_int === '') {
      missingFields.push('Address');
    }

    // Student District required if Regional Summer School or RSIP is selected
    if (interpretationState.districtDropdown_int && interpretationState.schoolDropdown_int &&
        (interpretationState.districtDropdown_int.includes("Regional Summer School") ||
         interpretationState.schoolDropdown_int.toString().includes("RSIP")) &&
        (!interpretationState.studentDistrictDropdown_int || interpretationState.studentDistrictDropdown_int === '')) {
      missingFields.push('Student District');
    }

    if (!interpretationState.contactName_int || interpretationState.contactName_int === '') {
      missingFields.push('Contact Name');
    }

    if (!interpretationState.contactPhone_int || interpretationState.contactPhone_int === '') {
      missingFields.push('Contact Phone');
    }

    if (!interpretationState.contactEmail_int || interpretationState.contactEmail_int === '') {
      missingFields.push('Contact Email');
    }

    if (!interpretationState.approverName_int || interpretationState.approverName_int === '') {
      missingFields.push('Approver Name');
    }

    if (!interpretationState.approverPosition_int || interpretationState.approverPosition_int === '') {
      missingFields.push('Approver Position');
    }

    if (!interpretationState.approverEmail_int || interpretationState.approverEmail_int === '') {
      missingFields.push('Approver Email');
    }

    // COSER required if Nassau BOCES is selected
    if (interpretationState.districtDropdown_int &&
        interpretationState.districtDropdown_int.includes("Nassau BOCES") &&
        (!interpretationState.coser_int || interpretationState.coser_int === '')) {
      missingFields.push('COSER');
    }

    return missingFields;
  };

  // Solution 3: Sync DOM values before validation
  const syncDOMValuesToState = () => {
    const inputs = document.querySelectorAll('input, textarea, select');
    let syncedCount = 0;

    inputs.forEach((input) => {
      // Skip MUI internal elements
      if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
        return;
      }

      if (input.id && input.value) {
        const stateValue = interpretationState[input.id];
        if (!stateValue || stateValue !== input.value) {
          console.log(`Syncing DOM value for: ${input.id} = ${input.value}`);
          syncedCount++;
          mapToRedux(input.id, input.value);
          updateColumn2Count(input.id, input.value);
        }
      }
    });

    console.log(`Synced ${syncedCount} fields from DOM to state`);
    return syncedCount;
  };

  function runAllValidations (){
    // Sync autofilled values before validation
    const syncedCount = syncDOMValuesToState();

    // Function to check validation and provide feedback
    const checkAndProceed = () => {
      // Update the validation state
      updateColumn2Count();

      let passed = true;
      const missingFields = getMissingRequiredFields();
      const validationErrors = [];

      // Contact Phone validation
      if (interpretationState.contactPhone_int && !validatePhone(interpretationState.contactPhone_int)) {
        setValidation_contactPhone('*Please provide a 10 digit phone')
        validationErrors.push('Contact Phone: must be a valid 10-digit phone number (no ext)');
        passed = false;
      }
      else setValidation_contactPhone('')

      // Contact Email validation
      if (interpretationState.contactEmail_int && !validateEmail(interpretationState.contactEmail_int)) {
        setValidation_contactEmail('*Please provide a valid email')
        validationErrors.push('Contact Email: must be a valid email address');
        passed = false;
      }
      else setValidation_contactEmail('')

      // Approver Email validation
      if (interpretationState.approverEmail_int && !validateEmail(interpretationState.approverEmail_int)) {
        setValidation_approverEmail('*Please provide a valid email')
        validationErrors.push('Approver Email: must be a valid email address');
        passed = false;
      }
      else setValidation_approverEmail('')

      // Guardian Phone validation
      if (interpretationState.needInterpreterChecked_int){
        if (interpretationState.phone_int && !validatePhone(interpretationState.phone_int)) {
          setValidation_studentPhone('*Please provide a 10 digit phone')
          validationErrors.push('Parent/Guardian Phone: must be a valid 10-digit phone number (no ext)');
          passed = false;
        }
        else setValidation_studentPhone('')
      }

      // COSER validation
      if (interpretationState.districtDropdown_int && interpretationState.districtDropdown_int.includes("Nassau BOCES")){
        if (!validateCOSER(interpretationState.coser_int)) {
          setValidation_coser('*Please provide a valid 3 digit coser')
          validationErrors.push('COSER: Must be your 3 digit COSER');
          passed = false;
        }
        else setValidation_coser('')
      } else setValidation_coser('')

      if (passed && missingFields.length === 0){
        handleThisContinueButton("testing")
      }
      else{
        // Show modal with missing fields and validation errors
        setValidationModalMissingFields(missingFields);
        setValidationModalErrors(validationErrors);
        setValidationModalOpen(true);
      }
    };

    if (syncedCount > 0) {
      console.log(`Synced ${syncedCount} autofilled fields before validation`);
      // Give a moment for state to update after sync
      setTimeout(checkAndProceed, 200);
    } else {
      // No sync needed, check immediately
      checkAndProceed();
    }
  }
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validatePhone(phone)
  {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if(phone.match(phoneno)) return true;
    else return false;
  }
  function validateCOSER(coser){
    var coserno = /^\d{3}$/
    if(coser.match(coserno)) return true;
    else return false;
  }
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
    // Mapping
    const mapToRedux = (id, valueInInput) => {
      console.log(interpretationState.leftColFilledOut + interpretationState.rightColFilledOut)
      switch (id) {
        case "dueDate_int":
          // Handle both Date objects (from date picker) and strings (from autofill)
          if (valueInInput instanceof Date) {
            dispatch(dueDate_intUpdated(valueInInput.toISOString()));
          } else if (typeof valueInInput === 'string') {
            dispatch(dueDate_intUpdated(valueInInput));
          }
          break;
        case "dueTime_int":
          // Handle both event objects (from time picker) and strings (from autofill)
          if (valueInInput && valueInInput.target) {
            valueInInput = valueInInput.target.value;
          }
          dispatch(dueTime_intUpdated(valueInInput));
          break;
        case "interpretationTypes_int":
          dispatch(interpretationTypes_intUpdated(valueInInput));
          break;
        case "testingSubject_int":
          dispatch(testingSubject_intUpdated(valueInInput));
          break;
        case "estimatedDurationHrs_int":
          dispatch(estimatedDurationHrs_intUpdated(valueInInput));
          break;
        case "estimatedDurationMins_int":
          dispatch(estimatedDurationMins_intUpdated(valueInInput));
          break;
        case "paperWorkChecked_int":
          dispatch(paperWorkChecked_intUpdated(valueInInput));
          break;
        case "needInterpreterChecked_int":
          dispatch(needInterpreterChecked_intUpdated(valueInInput));
          break;
        case "inPersonMeetingChecked_int":
          dispatch(inPersonMeetingChecked_intUpdated(valueInInput));
          break;
        case "teleconference_int":
          dispatch(teleconference_intUpdated(valueInInput));
          break;
        case "teleconferencePhone_int":
          dispatch(teleconferencePhone_intUpdated(valueInInput));
          break;
        case "onlineOrVirtChecked_int":
          dispatch(onlineOrVirtChecked_intUpdated(valueInInput));
          break;
        case "onlineMeetingLink_int":
          dispatch(onlineMeetingLink_intUpdated(valueInInput));
          break;
        case "studentName_int":
          dispatch(studentName_intUpdated(valueInInput));
          break;
        case "phone_int":
          dispatch(phone_intUpdated(valueInInput));
          break;
        case "grade_int":
          dispatch(grade_intUpdated(valueInInput));
          break;
        case "gender_int":
          dispatch(gender_intUpdated(valueInInput));
          break;
        case "languageDropdown_int":
          dispatch(languageDropdown_intUpdated(valueInInput));
          break;
        case "otherLanguages_int":
          dispatch(otherLanguages_intUpdated(valueInInput));
          break;
        case "districtDropdown_int":
          dispatch(districtDropdown_intUpdated(valueInInput));
          break;
        case "studentDistrictDropdown_int":
          dispatch(studentDistrictDropdown_intUpdated(valueInInput))
          break;
        case "schoolDropdown_int":
          dispatch(schoolDropdown_intUpdated(valueInInput));
          break;
        case "address_int":
          dispatch(address_intUpdated(valueInInput));
          break;
        case "contactName_int":
          dispatch(contactName_intUpdated(valueInInput));
          break;
        case "contactPhone_int":
          dispatch(contactPhone_intUpdated(valueInInput));
          break;
        case "contactEmail_int":
          dispatch(contactEmail_intUpdated(valueInInput));
          break;
        case "approverName_int":
          dispatch(approverName_intUpdated(valueInInput));
          break;
        case "approverPosition_int":
          dispatch(approverPosition_intUpdated(valueInInput));
          break;
        case "approverEmail_int":
          dispatch(approverEmail_intUpdated(valueInInput));
          break;
        case "districtRid_int":
          dispatch(districtRid_intUpdated(valueInInput));
          break;
        case "schoolRid_int":
          dispatch(schoolRid_intUpdated(valueInInput));
          break;
        case "approverSignatureFile_int":
          dispatch(approverSignatureFile_intUpdated(valueInInput));
          break;
        case "tableData_int":
          dispatch(tableData_intUpdated(valueInInput));
          break;
        case "notes_int":
          dispatch(notes_intUpdated(valueInInput));
          break;
        case "coser_int":
          dispatch(coser_intUpdated(valueInInput));
          break;
        case "docToInterpret_int":
          dispatch(docToInterperateFiles_intUpdated(valueInInput));
          break;
  
        default:
          console.log("ID not found: " + id)
      }
    }
    //////////////////////////////////////////////////////////////

  return (
    <ThemeProvider theme={useStyles}>
      <ValidationModal
        open={validationModalOpen}
        onClose={() => setValidationModalOpen(false)}
        missingFields={validationModalMissingFields}
        validationErrors={validationModalErrors}
      />
    {
      renderOtherInterpAlert()
    }
    <div>{/* className={classes.root}>*/}
      <FadeIn delay={200} duration={450}>
          <Container fluid className="">



              <Row>
                <Col>
                  <ProgressBar 
                    key={0} 
                    bgcolor={"#00695c"}
                    completed={interpretationState.progressBar} 
                    fixedClass={progressBarClass}
                  />
                  <MySectionBlock 
                    height="5px" 
                    onEnterViewport={() => {
                        console.log('enter viewportttt')
                        setProgressBarClass('')
                    }}
                    onLeaveViewport={() => {
                        console.log('leave viewportttt')
                        setProgressBarClass('progressBar-fixed')
                    }}
                  />
                </Col>
              </Row>



            {/* Content */}
            <Row>
              <Row>
                <Box style={{width: '60%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
                  <Card variant="outlined" style={{padding: '10px',}}>
                    <CardContent>
                {/*District Information*/}
                <Row>
                  <Col>
                    <p className="assessment-section-headers">District Information</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                        <Dropdown_Advanced required={true}valueInField={interpretationState.districtDropdown_int} classesToAdd={"required-adjusted-lower"} options={districts} prompt='District' id="districtDropdown_int" label="name" triggerUpdateInParent={mapToRedux} />
                        &nbsp;&nbsp; {/*lazy*/}
                        <Dropdown_Advanced required={true} valueInField={interpretationState.schoolDropdown_int} classesToAdd={"unrequired-adjusted-lower"} options={schools} condReset={resetDropdownValOnConditionalChange}
                          prompt='School' id="schoolDropdown_int" label="name" triggerUpdateInParent={mapToRedux}
                          isConditional={true} conditionalField={interpretationState.districtDropdown_int} />
                        {
                          interpretationState.districtDropdown_int && interpretationState.districtDropdown_int.includes("Nassau BOCES") && <>&nbsp;&nbsp; {/*lazy*/}<TextFields_Outlined valueInField={interpretationState.coser_int} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="coser_int" label="COSER (ex: 602)" /></>
                        }

                    </div>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                        <TextFields_Outlined_Long required={true} valueInField={interpretationState.address_int} classesToAdd={"unrequired-adjusted-lower long-input"} triggerUpdateInParent={mapToRedux} id="address_int" label="Address" />

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                      {
                          (interpretationState.districtDropdown_int && interpretationState.districtDropdown_int.includes("Regional Summer School")) ||
                          (interpretationState.schoolDropdown_int && interpretationState.schoolDropdown_int.toString().includes("RSIP"))
                          ?
                            <Dropdown_Advanced required={true} valueInField={interpretationState.studentDistrictDropdown_int} classesToAdd={"required-adjusted-lower"} options={districts} prompt='Student District' id="studentDistrictDropdown_int" label="name" triggerUpdateInParent={mapToRedux} />
                          : <></>
                      }
                    </div>
                  </Col>
                </Row>
                {/*Whom evaluation report(s) will be sent to*/}
                <Row>
                 <Col>
                  <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                    <p className="assessment-section-headers">Interpreter confirmation will be sent to</p>
                      {/* Contact Info */}
                      <TextFields_Outlined required={true} valueInField={interpretationState.contactName_int} classesToAdd={"required-adjusted-lower"} triggerUpdateInParent={mapToRedux} id="contactName_int" label="Contact Name" />
                      &nbsp;&nbsp; {/*lazy*/}
                      <TextFields_Outlined required={true} valueInField={interpretationState.contactPhone_int} classesToAdd={"required-adjusted-lower"} validationText={validate_contactPhone} noSpaces={true} triggerUpdateInParent={mapToRedux} id="contactPhone_int" label="Contact Phone" />
                      &nbsp;&nbsp; {/*lazy*/}
                      <TextFields_Outlined required={true} valueInField={interpretationState.contactEmail_int} classesToAdd={"required-adjusted-lower"} validationText={validate_contactEmail} noSpaces={true} triggerUpdateInParent={mapToRedux} id="contactEmail_int" label="Contact Email" />
                  </div>
                 </Col>
                </Row>
                {/*Whom evaluation report(s) will be approved by*/}
                <Row>
                  <Col>
                    <p className="assessment-section-headers">The request will be approved by</p>
                  </Col>
                </Row>
                {/* Approver Info */}
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                      <TextFields_Outlined valueInField={interpretationState.approverName_int} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="approverName_int" label="Approver Name" />
                      &nbsp;&nbsp; {/*lazy*/}
                      <TextFields_Outlined valueInField={interpretationState.approverPosition_int} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="approverPosition_int" label="Approver Position" />
                      &nbsp;&nbsp; {/*lazy*/}
                      <TextFields_Outlined valueInField={interpretationState.approverEmail_int} classesToAdd={"required-adjusted-lower"} validationText={validate_approverEmail} noSpaces={true} required={true} triggerUpdateInParent={mapToRedux} id="approverEmail_int" label="Approver Email" />
                    </div>
                  </Col>
                </Row>
                {/* District Information */}
                <Row>
                  <Col>
                    <p className="assessment-section-headers">Student Information</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                      <TextFields_Outlined valueInField={interpretationState.studentName_int} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="studentName_int" label="Student Name" />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '0px', marginBottom: '0px' }}>
                      <Dropdown_Advanced required={true} valueInField={interpretationState.grade_int} classesToAdd={"unrequired-adjusted-lower"} options={grades} prompt='Grade' id="grade_int" label="name" triggerUpdateInParent={mapToRedux} />
                      &nbsp;&nbsp;{/*lazy*/}
                      <Dropdown_Advanced required={true} valueInField={interpretationState.languageDropdown_int} classesToAdd={"required-adjusted-lower"} options={languages} prompt='Language' renderOther={setRenderOtherLang} id="languageDropdown_int" label="name" triggerUpdateInParent={mapToRedux} />
                      {
                        interpretationState.languageDropdown_int === "Other" && <>&nbsp;&nbsp;<TextFields_Outlined valueInField={interpretationState.otherLanguages_int} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="otherLanguages_int" label="Other Language" /></>
                      }
                    </div>
                  </Col>
                </Row>
                {/* Interpretation Info */}
                <Row>
                  <Col>
                    <p className="assessment-section-headers">Interpretation Info</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '0px', paddingLeft: '8px' }}>
                      <div style={{ width: '80%'}}>
                        <MultiSelect_Checkbox_Outlined required={true} valueInField={interpretationState.interpretationTypes_int} classesToAdd={"required"} triggerUpdateInParent={mapToRedux} handleTranslationTypeChanges={handleTranslationTypeChanges} label="Interpretation Type(s)" id="interpretationTypes_int" choices={["Annual Review", "CPSE/CSE Meeting", "Disciplinary Meeting", "Evaluation", "Family Meeting", "Graduation", "Parent/Teacher Conference", "Superintendent's Hearing", "Testing", "Large Group Meeting", "Other"]} />
                      </div>
                    </div>
                  </Col>
                </Row>

                {interpretationState.interpretationTypes_int && interpretationState.interpretationTypes_int.includes("Testing") ? (
                    <Row>
                    <Col>
                      <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '0px', marginBottom: '4px' }}>
                        <TextFields_Outlined required={true} valueInField={interpretationState.testingSubject_int} classesToAdd={"required-adjusted-lower"} triggerUpdateInParent={mapToRedux} id="testingSubject_int" label="Testing Subject" />
                      </div>
                    </Col>
                  </Row>
                  ) :
                  <></>

                }
                
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', }}>
                      <Checkbox_Regular valueInField={interpretationState.paperWorkChecked_int} id="paperWorkChecked_int" triggerUpdateInParent={mapToRedux} label="Paper work is required from family."/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', }}>
                      <Checkbox_Regular valueInField={interpretationState.needInterpreterChecked_int} id="needInterpreterChecked_int" triggerUpdateInParent={mapToRedux} updateValueInParent={setIsNeedInterpreterChecked} label="We need the interpreter to advise family of this meeting."/>
                    {interpretationState.needInterpreterChecked_int && <TextFields_Outlined valueInField={interpretationState.phone_int} classesToAdd={"required-adjusted-lower"} validationText={validate_studentPhone} required={true} triggerUpdateInParent={mapToRedux} id="phone_int" label="Parent/Guardian Phone" />}
                    
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', }}>
                      <Checkbox_Regular valueInField={interpretationState.inPersonMeetingChecked_int} id="inPersonMeetingChecked_int" triggerUpdateInParent={mapToRedux} label="In-Person Meeting"/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', }}>
                      <Checkbox_Regular valueInField={interpretationState.onlineOrVirtChecked_int} id="onlineOrVirtChecked_int" triggerUpdateInParent={mapToRedux} updateValueInParent={setIsOnlineOrVirtualMeeting} label="Online or Virtual Meeting"/>
                      {isOnlineOrVitrualMeeting && <TextFields_Outlined valueInField={interpretationState.onlineMeetingLink_int} required={false} triggerUpdateInParent={mapToRedux} id="onlineMeetingLink_int" label="Meeting Link" />}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', }}>
                      <Checkbox_Regular valueInField={interpretationState.teleconference_int} id="teleconference_int" triggerUpdateInParent={mapToRedux} updateValueInParent={setIsTeleconference} label="Teleconference"/>
                      {isTeleconference && <TextFields_Outlined valueInField={interpretationState.teleconferencePhone_int} required={false} triggerUpdateInParent={mapToRedux} id="teleconferencePhone_int" label="Teleconference Phone" />}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '0px', marginLeft: '8px' }}>
                        <b>Notes:</b>
                        <TextArea_Simple id="notes_int"
                        required={interpretationState.interpretationTypes_int && interpretationState.interpretationTypes_int.includes("Other") ? true : false}
                          classesToAdd={""}
                          valueInField={interpretationState.notes_int}
                          triggerUpdateInParent={mapToRedux}
                          placeholder="Please enter any notes such as alternate dates, times or Interpretation Types." 
                          rows={3} 
                          minrows={3} 
                          maxrows={5} 
                        />
                    </div>
                  </Col>
                </Row>

                {/* Interpretation Info */}
                <Row>
                  <Col>
                    <p className="assessment-section-headers">Interpretation Time & Duration</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', lineHeight: '.25' }}>
                      <b className={"required"} style={{textAlign:'center !important'}}><span style={{color:'red'}}>*</span>Date/Time</b>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '18px',  }}>
                          <DatePicker_Simple minDate={today} valueInField={new Date(interpretationState.dueDate_int) | ''} triggerUpdateInParent={mapToRedux} id="dueDate_int" className="" label="Date" selected={startDueDate} onChange={date => setStartDueDate(date)} />
                        &nbsp;&nbsp;{/*lazy*/}
                        <TimePicker valueInField={interpretationState.dueTime_int} classesToAdd={"adjust-time-height-fix"} triggerUpdateInParent={mapToRedux} id="dueTime_int" className="date-picker-main-time" label="" selected={startDueTime} onChange={date => setStartDueTime(date)} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px' }}>
                    {
                      interpretationState.languageDropdown_int=="ASL" && <b className={""} style={{textAlign:'right',color:'red'}}>*Please note: 2-hour minimum for ASL</b>
                    }
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', lineHeight: '.25' }}>
                      <b className={"required"} style={{textAlign:'center !important'}}><span style={{color:'red'}}>*</span>Estimated Duration</b>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '7px', marginLeft: '5px' }}>
                      <div style={{width:'80px'}}><TextFields_Outlined valueInField={interpretationState.estimatedDurationHrs_int} required={false} triggerUpdateInParent={mapToRedux} id="estimatedDurationHrs_int" label="Hrs" /></div>
                      &nbsp;&nbsp;{/*lazy*/}
                      <div style={{width:'82px'}}><TextFields_Outlined valueInField={interpretationState.estimatedDurationMins_int} required={false} triggerUpdateInParent={mapToRedux} id="estimatedDurationMins_int" label="Mins" /></div>
                    </div>
                  </Col>
                </Row>

              </CardContent>
            </Card>
          </Box>
                
              </Row>
              
            </Row>
            <Row>
                <Col>
                  <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', paddingTop: '20px', width: '60%' }}>
                    <p><b style={{color: '#f50057'}}>*24 Hour Cancellation Notice Needed or district will be charged.</b></p>
                  </div>
                </Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>

          </Container>
          <div className="form-button-bottom-container">
            <Button className="btn btn-primary form-button-bottom" onClick={() => runAllValidations()}
              variant="contained" color="primary">
              Next Page
            </Button>
          </div>
      </FadeIn>
    </div>
    </ThemeProvider>
  )
}

export default TranslationContent
